<div class="client-information-entry-container">
  <div class="client-information-entry" [ngClass]="_containerClass">
    <span class="client-information-key">{{ key | translate }}</span
    ><span class="client-information-value">{{
      showPlaceHolder() ? placeholder : value
    }}</span>
  </div>
</div>
